import React from "react";
import { useTranslation } from "react-i18next";
import CenterModal from "../../../mobilecomponent/CenterModal";

const ImageSizeBig = ({ showImageBig }) => {
  const { t } = useTranslation();
  const closebasic = "/images/mo/closebasic.svg";
  const jangruboy_wow = "/images/mo/jangruboy_wow.svg";
  const imagebigKey = true;
  return (
    <CenterModal showImageBig={showImageBig} imagebigKey={imagebigKey}>
      <img
        src={closebasic}
        alt="closebasic"
        className="absolute top-0 right-0 cursor-pointer"
        onClick={showImageBig}
      />
      <div className="wordbreak-keepall flex flex-col items-center">
        <img src={jangruboy_wow} alt="jangruboywow" />
        <div className="pt-[16px]">{t('ImageSizeBig_file_size_limit', '15MB 이하의 파일만 추가 가능합니다.')}</div>
        <div>{t('ImageSizeBig_check_file_size', '파일 사이즈를 확인해주세요!')}</div>
      </div>
    </CenterModal>
  );
};

export default ImageSizeBig;
